import script from "./DrillHoleGridSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./DrillHoleGridSettings.vue?vue&type=script&setup=true&lang=ts"

import "./DrillHoleGridSettings.vue?vue&type=style&index=0&id=e36cd404&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e36cd404"]])

export default __exports__